import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Well, Modal, Button } from '../../../index.js';
import Betalingspaakrav from '../../CreateTribunalCase/types/Betalingspaakrav/index.js';
import GLBetalingspaakrav from '../../CreateTribunalCase/types/GLBetalingspaakrav/index.js';
import { TribunalJobType, } from '@debbie/common/dist/tribunal/jobs/types.js';
const ResendBetalingspaakrav = (props) => {
    const lang = useSelector((s) => s.lang);
    const [open, setOpen] = useState(false);
    const createBpkJob = props.pastJobs.find((job) => job.type === TribunalJobType.CreateBetalingspaakrav);
    const createGLBpkJob = props.pastJobs.find((job) => job.type === TribunalJobType.GLCreateBetalingspaakrav);
    return (React.createElement("div", null,
        React.createElement("h4", null, lang.tribunal.resendBPK),
        React.createElement(Button, { block: true, onClick: () => setOpen(!open) }, lang.tribunal.editBPK),
        open && (React.createElement(Modal, { header: lang.tribunal.resendBPK, onToggle: () => setOpen(!open) },
            React.createElement(Well, null, props.is_greenland ? (React.createElement(GLBetalingspaakrav, { caseSeqId: props.caseSeqId, tenantId: props.tenantId, tribunalCaseId: createBpkJob?.tribunalCaseId, resending: true, onCreated: () => setOpen(false), prefill: createGLBpkJob && {
                    sagsfremstilling: createGLBpkJob.data.sagsfremstilling,
                    courtFee: createGLBpkJob.data.courtFee,
                    courtId: createGLBpkJob.data.courtId,
                    remindingDate: createGLBpkJob.data.remindingDate,
                    createDate: createGLBpkJob.data.createDate,
                    processInterest: createGLBpkJob.data.processInterest,
                    preventForkyndt: createGLBpkJob.data.preventForkyndt,
                    preventAutDistress: createGLBpkJob.data.preventAutDistress,
                    notDirectlyToCivilCourt: createGLBpkJob.data.notDirectlyToCivilCourt,
                    sendInfoToEconomyResponsible: false,
                    addCourtFeeToCase: false,
                    addCourtDisbursementToClientBilling: false,
                    addCourtFeeToClientBilling: false,
                    interestDates: createGLBpkJob.data.interestDates,
                    interests: createGLBpkJob.data.interests,
                    totalAmount: createGLBpkJob.data.totalAmount,
                    participatePhoneMeeting: createGLBpkJob.data.participatePhoneMeeting,
                } })) : (React.createElement(Betalingspaakrav, { caseSeqId: props.caseSeqId, tenantId: props.tenantId, tribunalCaseId: createBpkJob?.tribunalCaseId, resending: true, onCreated: () => setOpen(false), prefill: createBpkJob && {
                    sagsfremstilling: createBpkJob.data.sagsfremstilling,
                    courtFee: createBpkJob.data.courtFee,
                    courtId: createBpkJob.data.courtId,
                    remindingDate: createBpkJob.data.remindingDate,
                    createDate: createBpkJob.data.createDate,
                    processInterest: createBpkJob.data.processInterest,
                    preventForkyndt: createBpkJob.data.preventForkyndt,
                    preventAutDistress: createBpkJob.data.preventAutDistress,
                    notDirectlyToCivilCourt: createBpkJob.data.notDirectlyToCivilCourt,
                    sendInfoToEconomyResponsible: false,
                    addCourtFeeToCase: false,
                    addCourtDisbursementToClientBilling: false,
                    addCourtFeeToClientBilling: false,
                    interestDates: createBpkJob.data.interestDates,
                    interests: createBpkJob.data.interests,
                    totalAmount: createBpkJob.data.totalAmount,
                } })))))));
};
export default ResendBetalingspaakrav;
//# sourceMappingURL=ResendBetalingspaakrav.js.map